// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mdash {
    --md-blue: #1d4ed8;
    --md-green: #15803d;
    --md-red: #dc2626;
    --md-teal: #0f766e;
    --md-ink: #0f172a;
    --md-muted: #64748b;
    --md-line: #e2e8f0;
}

.mdash-chrome {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
}

.mdash-crumb {
    font-size: 13px;
    color: var(--md-muted);
    margin: 0;
}

.mdash-crumb strong {
    color: var(--md-ink);
    font-weight: 600;
}

.mdash-chrome-icons {
    display: flex;
    gap: 8px;
}

.mdash-icon-btn {
    width: 36px;
    height: 36px;
    border: 1px solid var(--md-line);
    border-radius: 999px;
    background: #fff;
    color: #334155;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.mdash-banner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 28px 32px;
    border-radius: 16px;
    background: linear-gradient(90deg, #123a8a 0%, #0e7c6b 100%);
    color: #fff;
    margin-bottom: 20px;
}

.mdash-banner-kicker {
    font-size: 13px;
    opacity: 0.85;
    margin: 0 0 4px;
}

.mdash-banner-name {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    margin: 0 0 6px;
}

.mdash-banner-meta {
    font-size: 14px;
    opacity: 0.92;
    margin: 0;
}

.mdash-mentees-badge {
    background: #fff;
    color: var(--md-ink);
    border-radius: 14px;
    padding: 14px 18px;
    min-width: 140px;
    text-align: center;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.mdash-mentees-badge i {
    font-size: 22px;
    color: var(--md-teal);
}

.mdash-mentees-badge-label {
    display: block;
    font-size: 11px;
    letter-spacing: 0.08em;
    font-weight: 700;
    color: var(--md-muted);
    margin-top: 4px;
}

.mdash-mentees-badge-count {
    display: block;
    font-size: 14px;
    font-weight: 600;
}

.mdash-kpis {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.mdash-kpi {
    background: #fff;
    border: 1px solid var(--md-line);
    border-radius: 12px;
    padding: 18px 16px;
}

.mdash-kpi-label {
    display: block;
    font-size: 11px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--md-muted);
    font-weight: 600;
    margin-bottom: 6px;
}

.mdash-kpi-value {
    display: block;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 6px;
}

.mdash-kpi-value.is-blue {
    color: var(--md-blue);
}

.mdash-kpi-value.is-green {
    color: var(--md-green);
}

.mdash-kpi-value.is-red {
    color: var(--md-red);
}

.mdash-kpi-value.is-teal {
    color: var(--md-teal);
}

.mdash-kpi-sub {
    font-size: 12px;
    color: var(--md-muted);
    margin: 0;
}

.mdash-section-title {
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 12px;
    color: var(--md-ink);
}

.mdash-next {
    display: flex;
    gap: 16px;
    align-items: stretch;
    background: #fff;
    border: 1px solid var(--md-line);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 24px;
}

.mdash-next-date {
    min-width: 64px;
    border-radius: 10px;
    background: #f1f5f9;
    color: var(--md-muted);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 8px;
    font-weight: 700;
}

.mdash-next-copy {
    margin: 0;
    color: var(--md-muted);
    font-size: 14px;
}

.mdash-widgets {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.mdash-widget {
    background: #fff;
    border: 1px solid var(--md-line);
    border-radius: 12px;
    padding: 16px 18px;
}

.mdash-widget-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.mdash-widget-head h2 {
    font-size: 13px;
    font-weight: 700;
    margin: 0;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

.mdash-widget-head a,
.mdash-link-btn {
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
    color: var(--md-blue);
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.mdash-next-date-month {
    font-size: 11px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

.mdash-next-date-day {
    font-size: 20px;
    line-height: 1.1;
}

.mdash-next-title {
    margin: 0 0 4px;
    font-weight: 600;
    color: var(--md-ink);
    font-size: 14px;
}

.mdash-mentee-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 0;
    border-top: 1px solid #f1f5f9;
}

.mdash-mentee-row:first-of-type {
    border-top: 0;
    padding-top: 0;
}

.mdash-avatar {
    width: 40px;
    height: 40px;
    border-radius: 999px;
    background: #dbeafe;
    color: #1e3a8a;
    font-size: 13px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.mdash-mentee-name {
    font-weight: 600;
    margin: 0 0 2px;
    color: var(--md-ink);
}

.mdash-mentee-meta {
    font-size: 12px;
    color: var(--md-muted);
    margin: 0 0 6px;
}

.mdash-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 8px;
}

.mdash-chip {
    font-size: 11px;
    background: #ecfdf5;
    color: #065f46;
    border-radius: 999px;
    padding: 2px 8px;
}

.mdash-row-actions {
    display: flex;
    gap: 8px;
}

.mdash-row-actions .btn {
    font-size: 12px;
    padding: 4px 10px;
}

.mdash-empty {
    color: var(--md-muted);
    font-size: 14px;
    margin: 0;
}

@media (max-width: 991px) {
    .mdash-kpis,
    .mdash-widgets {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 767px) {
    .mdash-kpis,
    .mdash-widgets {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/mentorship/mentorDashboard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,4DAA4D;IAC5D,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,SAAS;AACb;;AAEA;IACI;;QAEI,8BAA8B;IAClC;AACJ;;AAEA;IACI;;QAEI,0BAA0B;IAC9B;AACJ","sourcesContent":[".mdash {\n    --md-blue: #1d4ed8;\n    --md-green: #15803d;\n    --md-red: #dc2626;\n    --md-teal: #0f766e;\n    --md-ink: #0f172a;\n    --md-muted: #64748b;\n    --md-line: #e2e8f0;\n}\n\n.mdash-chrome {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 8px;\n}\n\n.mdash-crumb {\n    font-size: 13px;\n    color: var(--md-muted);\n    margin: 0;\n}\n\n.mdash-crumb strong {\n    color: var(--md-ink);\n    font-weight: 600;\n}\n\n.mdash-chrome-icons {\n    display: flex;\n    gap: 8px;\n}\n\n.mdash-icon-btn {\n    width: 36px;\n    height: 36px;\n    border: 1px solid var(--md-line);\n    border-radius: 999px;\n    background: #fff;\n    color: #334155;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n}\n\n.mdash-banner {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 28px 32px;\n    border-radius: 16px;\n    background: linear-gradient(90deg, #123a8a 0%, #0e7c6b 100%);\n    color: #fff;\n    margin-bottom: 20px;\n}\n\n.mdash-banner-kicker {\n    font-size: 13px;\n    opacity: 0.85;\n    margin: 0 0 4px;\n}\n\n.mdash-banner-name {\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 1.2;\n    margin: 0 0 6px;\n}\n\n.mdash-banner-meta {\n    font-size: 14px;\n    opacity: 0.92;\n    margin: 0;\n}\n\n.mdash-mentees-badge {\n    background: #fff;\n    color: var(--md-ink);\n    border-radius: 14px;\n    padding: 14px 18px;\n    min-width: 140px;\n    text-align: center;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);\n}\n\n.mdash-mentees-badge i {\n    font-size: 22px;\n    color: var(--md-teal);\n}\n\n.mdash-mentees-badge-label {\n    display: block;\n    font-size: 11px;\n    letter-spacing: 0.08em;\n    font-weight: 700;\n    color: var(--md-muted);\n    margin-top: 4px;\n}\n\n.mdash-mentees-badge-count {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.mdash-kpis {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.mdash-kpi {\n    background: #fff;\n    border: 1px solid var(--md-line);\n    border-radius: 12px;\n    padding: 18px 16px;\n}\n\n.mdash-kpi-label {\n    display: block;\n    font-size: 11px;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--md-muted);\n    font-weight: 600;\n    margin-bottom: 6px;\n}\n\n.mdash-kpi-value {\n    display: block;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 1.1;\n    margin-bottom: 6px;\n}\n\n.mdash-kpi-value.is-blue {\n    color: var(--md-blue);\n}\n\n.mdash-kpi-value.is-green {\n    color: var(--md-green);\n}\n\n.mdash-kpi-value.is-red {\n    color: var(--md-red);\n}\n\n.mdash-kpi-value.is-teal {\n    color: var(--md-teal);\n}\n\n.mdash-kpi-sub {\n    font-size: 12px;\n    color: var(--md-muted);\n    margin: 0;\n}\n\n.mdash-section-title {\n    font-size: 16px;\n    font-weight: 700;\n    margin: 0 0 12px;\n    color: var(--md-ink);\n}\n\n.mdash-next {\n    display: flex;\n    gap: 16px;\n    align-items: stretch;\n    background: #fff;\n    border: 1px solid var(--md-line);\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 24px;\n}\n\n.mdash-next-date {\n    min-width: 64px;\n    border-radius: 10px;\n    background: #f1f5f9;\n    color: var(--md-muted);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 8px;\n    font-weight: 700;\n}\n\n.mdash-next-copy {\n    margin: 0;\n    color: var(--md-muted);\n    font-size: 14px;\n}\n\n.mdash-widgets {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\n.mdash-widget {\n    background: #fff;\n    border: 1px solid var(--md-line);\n    border-radius: 12px;\n    padding: 16px 18px;\n}\n\n.mdash-widget-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.mdash-widget-head h2 {\n    font-size: 13px;\n    font-weight: 700;\n    margin: 0;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n}\n\n.mdash-widget-head a,\n.mdash-link-btn {\n    font-size: 13px;\n    font-weight: 600;\n    text-decoration: none;\n    color: var(--md-blue);\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n}\n\n.mdash-next-date-month {\n    font-size: 11px;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n}\n\n.mdash-next-date-day {\n    font-size: 20px;\n    line-height: 1.1;\n}\n\n.mdash-next-title {\n    margin: 0 0 4px;\n    font-weight: 600;\n    color: var(--md-ink);\n    font-size: 14px;\n}\n\n.mdash-mentee-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px 0;\n    border-top: 1px solid #f1f5f9;\n}\n\n.mdash-mentee-row:first-of-type {\n    border-top: 0;\n    padding-top: 0;\n}\n\n.mdash-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 999px;\n    background: #dbeafe;\n    color: #1e3a8a;\n    font-size: 13px;\n    font-weight: 700;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.mdash-mentee-name {\n    font-weight: 600;\n    margin: 0 0 2px;\n    color: var(--md-ink);\n}\n\n.mdash-mentee-meta {\n    font-size: 12px;\n    color: var(--md-muted);\n    margin: 0 0 6px;\n}\n\n.mdash-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 8px;\n}\n\n.mdash-chip {\n    font-size: 11px;\n    background: #ecfdf5;\n    color: #065f46;\n    border-radius: 999px;\n    padding: 2px 8px;\n}\n\n.mdash-row-actions {\n    display: flex;\n    gap: 8px;\n}\n\n.mdash-row-actions .btn {\n    font-size: 12px;\n    padding: 4px 10px;\n}\n\n.mdash-empty {\n    color: var(--md-muted);\n    font-size: 14px;\n    margin: 0;\n}\n\n@media (max-width: 991px) {\n    .mdash-kpis,\n    .mdash-widgets {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n@media (max-width: 767px) {\n    .mdash-kpis,\n    .mdash-widgets {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
